import axios from 'axios'
import moment from 'moment'
import Deneric from 'deneric2'
import {ENV} from "@/apps/rever-academy/components/Constant";
import {data} from "jquery";


const BASE_ENDPOINT = process.env.contact_from_api
const DEFAULT_DESCRIPTION = ENV.VUE_APP_FORM_DESCRIPTION_NOTE || ''

class RegisterFormService {
  id: string | undefined
  constructor() {
    this.id = process.env.id_submit_form
  }
  submit(formData:any) {
    const url = `${BASE_ENDPOINT}/${this.id}`
    console.log("hhhhihi",formData)
    return axios.post(url,  formData)
  }
}

const instance: RegisterFormService = new RegisterFormService()

export class RegisterRequest {
    firstname: string = ''
  lastname: string = ''
  email: string = ''
  phone: string = ''
  class: any = []
  address: string = ''
  constructor(data:any = {}) {
    this.firstname = data.firstname || ''
    this.lastname = data.lastname || ''
    this.email = data.email || ''
    this.phone = data.phone || ''
    this.class = data.class || []
    this.address = data.address || ''
    // this.description_note = data.description_note || DEFAULT_DESCRIPTION
  }
}

export default instance


